import React, { useEffect } from "react";
import { useState } from "react";

import styles from "./compUpdateForm.module.scss";
import authService from "../../../utils/services/authService";
import { techStack } from "../../../utils/data/techStack";
import { useNavigate } from "react-router-dom";

const CompUpdateForm = ({ userData }) => {
  const [company, setCompany] = useState({
    companySize: "",
    companyType: "",
    tech: [],
    description: "",
    perks: [],
    contact: {
      address: "",
      zipCode: "",
      city: "",
      country: "",
      website: "",
    },
    createdProfile: false,
  });
  const navigate = useNavigate();
  // const userData = authService.getUserData();

  //Search mechanic states
  const [searchField, setSearchField] = useState("");
  const [stack, setStack] = useState(techStack);
  const [filteredStack, setFilteredStack] = useState(stack);

  //state for selected tech
  const [selectedTech, setSelectedTech] = useState([]);
  // select state
  const [numberOfPerks, setNumberOfPerks] = useState(0);
  const [perks, setPerks] = useState([]);

  useEffect(() => {
    const filteredStack = stack.filter((tech) => {
      return tech.name.toLowerCase().includes(searchField);
    });
    setFilteredStack(filteredStack);
  }, [stack, searchField]);

  useEffect(() => {
    if (userData.createdProfile) {
      navigate(`/profile/developer/${userData.userId}`);
    }
  }, []);

  useEffect(() => {
    setCompany({ ...company, tech: selectedTech });
  }, [selectedTech]);

  useEffect(() => {
    for (let i = 0; i < numberOfPerks; i++) {
      perks.push({ perkTitle: "", perkBody: "" });
    }
  }, [numberOfPerks]);

  const onSearchChange = (e) => {
    const searchFieldString = e.target.value.toLowerCase();
    setSearchField(searchFieldString);
  };

  //If nestedObj is === 'contact' insert the value in its correct nested objects. Else insert it by the name attribute.
  const onChangeHandle = (e, nestedObj) => {
    const value = e.target.value;
    if (nestedObj === "contact") {
      setCompany({
        ...company,
        contact: { ...company.contact, [e.target.name]: value },
      });
    } else {
      setCompany({ ...company, [e.target.name]: value });
    }
  };

  const techOnClickHandle = (e) => {
    const selected = e.target.getAttribute("data-value");

    if (selectedTech.includes(selected)) {
      return;
    } else {
      setSelectedTech([...selectedTech, selected]);
    }
  };

  const selectedOnClickHandle = (e) => {
    const remove = e.target.getAttribute("data-value");
    const clearedItems = selectedTech.filter((selected) => selected !== remove);
    setSelectedTech(clearedItems);
    setCompany({ ...company, tech: clearedItems });
  };

  const selectHandle = (e) => {
    const value = parseInt(e.target.value);
    let arr = [];
    for (let i = 0; i < value; i++) {
      arr.push({ perkTitle: "", perkBody: "" });
    }
    setPerks(arr);
  };

  const perksHandle = (e, index) => {
    let newPerks = [...perks];
    let perk = newPerks[index];

    if (e.target.name === "perkTitle" + index) {
      perk.perkTitle = e.target.value;
    } else if (e.target.name === "perkBody" + index) {
      perk.perkBody = e.target.value;
    }
    setPerks(newPerks);
  };

  const perksDoneHandle = (e) => {
    e.preventDefault();
    setCompany({ ...company, perks: perks });
  };

  const onSubmitHandle = async (e) => {
    e.preventDefault();
    const formData = {
      ...company,
    };

    formData.createdProfile = true;
    console.log(formData);
    const result = await authService.updateUser(
      userData.role,
      userData.userId,
      formData,
      userData
    );
    if (result?.data.success) {
      if (result.data.data.createdProfile) {
        updateLocalStorage();
        navigate(`/profile/company/${userData.userId}`);
      }
    }
  };

  const updateLocalStorage = () => {
    const ls = JSON.parse(localStorage.getItem("userData"));
    ls.createdProfile = true;
    localStorage.setItem("userData", JSON.stringify(ls));
  };
  return (
    <section className={styles.formWrapper}>
      <h1 className={styles.formWrapper_heading}>Update your profile</h1>
      <p className={styles.formWrapper_subHeading}>
        You need to fill out everything to continue
      </p>
      <form className={styles.updateForm} action="">
        <h3 className={styles.updateForm_heading}>Basic info</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="companySize">
            Company size
          </label>
          <input
            id="companySize"
            name="companySize"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g 0-10"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="companyType">
            Company type
          </label>
          <input
            id="companyType"
            name="companyType"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g Products"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="tech">
            Tech you work with
          </label>
          <input
            id="skills"
            className={styles.formGroup_input}
            type="search"
            // tabIndex="3"
            aria-label="Search tech and choose from list below"
            placeholder="Search tech and choose from list below"
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
          <div className={styles.displayStack}>
            <p>Click on the items to select tech</p>
            <div className={styles.itemsWrapper}>
              {filteredStack.map((tech, index) => (
                <span
                  key={index}
                  data-value={tech.name}
                  className={`${styles.itemsWrapper_item}`}
                  onClick={(e) => {
                    techOnClickHandle(e);
                  }}
                >
                  {tech.name}
                </span>
              ))}
            </div>
          </div>
          <div className={styles.techSelectedWrapper}>
            <p>You've chosen</p>
            <div className={styles.techSelected}>
              {selectedTech.map((selected, index) => (
                <span
                  key={index}
                  data-value={selected}
                  className={styles.techSelected_item}
                  onClick={(e) => {
                    selectedOnClickHandle(e);
                  }}
                >
                  {selected}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="description">
            Company description
          </label>
          <textarea
            id="description"
            name="description"
            className={styles.formGroup_textArea}
            type="text"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          ></textarea>
        </div>
        <h3 className={styles.updateForm_heading}>Perks</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="perks">
            Choose number of perks &#40;max 4&#41;
          </label>
          <select name="perks" id="perks" onChange={(e) => selectHandle(e)}>
            <option value="">Choose number of perks</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select>
          {perks.map((item, index) => (
            <div key={index} className={styles.perkWrapper}>
              <label
                className={styles.perkWrapper_label}
                htmlFor={`perkTitle${index}`}
              >
                Perk title
              </label>
              <input
                id={`perkTitle${index}`}
                className={styles.perkWrapper_input}
                name={`perkTitle${index}`}
                type="text"
                placeholder="Perk title"
                // value={item.perkTitle}
                onChange={(e) => {
                  perksHandle(e, index);
                }}
              />
              <label
                className={styles.perkWrapper_label}
                htmlFor={`perkBody${index}`}
              >
                Perk body
              </label>
              <input
                id={`perkBody${index}`}
                className={`${styles.perkWrapper_input} ${styles.perkWrapper_perkBody}`}
                name={`perkBody${index}`}
                type="text"
                placeholder="Perk body"
                // value={item.perkTitle}
                onChange={(e) => {
                  perksHandle(e, index);
                }}
              />
            </div>
          ))}
          <button onClick={(e) => perksDoneHandle(e)}>Done</button>
          {/* <input
            id="minSalary"
            name="minSalary"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g 30 000"
            onChange={(e) => {
              onChangeHandle(e, 'preferences');
            }}
          /> */}
        </div>
        <h3 className={styles.updateForm_heading}>Contact information</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="address">
            Address
          </label>
          <input
            id="address"
            name="address"
            className={styles.formGroup_input}
            type="text"
            placeholder="Address"
            onChange={(e) => {
              onChangeHandle(e, "contact");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="zipCode">
            Zip code
          </label>
          <input
            id="zipCode"
            name="zipCode"
            className={styles.formGroup_input}
            type="text"
            placeholder="Zip code"
            onChange={(e) => {
              onChangeHandle(e, "contact");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="city">
            City
          </label>
          <input
            id="city"
            name="city"
            className={styles.formGroup_input}
            type="text"
            placeholder="City"
            onChange={(e) => {
              onChangeHandle(e, "contact");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="country">
            Country
          </label>
          <input
            id="country"
            name="country"
            className={styles.formGroup_input}
            type="text"
            placeholder="Country"
            onChange={(e) => {
              onChangeHandle(e, "contact");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="website">
            Website
          </label>
          <input
            id="website"
            name="website"
            className={styles.formGroup_input}
            type="text"
            placeholder="Website"
            onChange={(e) => {
              onChangeHandle(e, "contact");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <button
            className={styles.formGroup_btn}
            onClick={(e) => {
              onSubmitHandle(e);
            }}
          >
            Update info
          </button>
        </div>
      </form>
    </section>
  );
};

export default CompUpdateForm;
